import React, { Component } from 'react';
import { compose } from 'recompose';
import { withAuth } from './AuthContext';
import { withFirebase } from '../firebase';
import { Loading } from '../layout';

import { upgradeMdl, emailRegExp } from '../../utils';

const Steps = {
  INITIAL: 'INITIAL',
  EMAIL: 'EMAIL',
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  GOOGLE: 'GOOGLE',
}

class AuthBase extends Component {

  static loadingContainerStyles = {
    display: 'flex',
    minHeight: '120px',
    justifyContent: 'center',
    alignItems: 'center',
  }

  state = {
    email: '',
    step: Steps.INITIAL,
    passwordError: null,
    emailError: null,
    processing: false,
  }

  componentDidMount() {
    const hasFireBaseKey = Object.keys(sessionStorage).some(key => key.includes('firebase:'));

    if (!hasFireBaseKey) return;

    this.setState({ step: Steps.GOOGLE, processing: true });

    this.props.firebase.handleGoogleLogin()
      .then((response) => {
        this.props.auth.updateUser(response.user, response.token, response.refreshToken);
        this.setState({ step: Steps.INITIAL, processing: false });
      })
      .catch(err => {
        this.setState({ step: Steps.INITIAL, processing: false });
        console.error(err);
      });
  }

  onEmailChange = event => this.setState({ email: event.target.value, emailError: null }, upgradeMdl);

  signInWithEmail = () => this.setState({ step: Steps.EMAIL }, upgradeMdl);
  goToInitialStep = () => this.setState({ step: Steps.INITIAL }, upgradeMdl);

  signInWithGoogle = () => {
    this.props.firebase.loginWithGoogle();
  };

  goToSecondStep = (event) => {
    event.preventDefault();
    this.setState({ processing: true });
    const email = document.getElementById('email').value;

    if (email.length < 4 || !emailRegExp.test(String(email).toLowerCase())) {
      return this.setState({ emailError: 'Invalid email', processing: false }, upgradeMdl);
    }

    this.props.firebase.isEmailUsed(email)
      .then(isUsed => {
        this.setState({ step: isUsed ? Steps.LOGIN : Steps.REGISTER, processing: false, emailError: null }, () => {
          document.getElementById('email').value = this.state.email;
          upgradeMdl();
        })
      })
      .catch(err => {
        console.error(err);
        this.setState({ emailError: err && err.message, processing: false }, upgradeMdl);
      })
  }

  register = (event) => {
    event.preventDefault();
    const email = document.getElementById('email').value;
    const password = document.getElementById('newPassword').value;
    const confirmPassword = document.getElementById('confirmPassword').value;

    if (password.length < 4) {
      return this.setState({ passwordError: 'Password is to short' }, upgradeMdl);
    }

    if (password !== confirmPassword) {
      return this.setState({ passwordError: 'Passwords are not the same' }, upgradeMdl);
    }

    this.setState({ passwordError: null, processing: true }, upgradeMdl);

    this.props.firebase.register(email, password)
      .then((response) => {
        this.props.auth.updateUser(response.user, response.token, response.refreshToken);
        this.setState({ step: Steps.INITIAL, processing: false }, upgradeMdl);
      })
      .catch(err => {
        console.error(err);
        this.setState({ passwordError: err && err.message, processing: false }, upgradeMdl);
      });
  }

  login = (event) => {
    event.preventDefault();
    const email = document.getElementById('email').value;
    const password = document.getElementById('currentPassword').value;

    if (password.length < 4) {
      return this.setState({ passwordError: 'Password is to short' }, upgradeMdl);
    }

    this.setState({ passwordError: null, processing: true }, upgradeMdl);

    this.props.firebase.login(email, password)
      .then((response) => {
        this.props.auth.updateUser(response.user, response.token, response.refreshToken);
        this.setState({ step: Steps.INITIAL, processing: false }, upgradeMdl);
      })
      .catch(err => {
        console.error(err);
        this.setState({ passwordError: err && err.message, processing: false }, upgradeMdl);
      });
  }

  renderEmailPasswordForm() {
    const { step, emailError, passwordError, processing } = this.state;
    const handler = step === Steps.EMAIL ? this.goToSecondStep : (step === Steps.LOGIN ? this.login : this.register);
    const actionButton = step === Steps.EMAIL ? 'Next' : (step === Steps.LOGIN ? 'Login' : 'Register');

    return (
      <div className="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-in">
        <form onSubmit={handler}>
          <div className="firebaseui-card-header">
            { step !== Steps.GOOGLE ? <h1 className="firebaseui-title">
              {
                step === Steps.EMAIL ? 'Sign in with email' : (
                  step === Steps.REGISTER ? 'Register' : 'Login'
                )
              }
            </h1> : <h1 className="firebaseui-title">Login...</h1>}
          </div>
          <div className="firebaseui-card-content">
            { processing ? <div style={AuthBase.loadingContainerStyles}><Loading /></div> : <div className="firebaseui-relative-wrapper">

              <div className={`firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label is-upgraded ${step !== Steps.EMAIL ? 'is-dirty' : ''}`}>
                <label className="mdl-textfield__label firebaseui-label" htmlFor="email">Email</label>
                <input autoFocus disabled={step !== Steps.EMAIL} onChange={this.onEmailChange} id="email" type="email" name="email" autoComplete="email" className="mdl-textfield__input firebaseui-input firebaseui-id-email" />
              </div>

              { emailError ? <div className="firebaseui-error-wrapper">
                <p className="firebaseui-error firebaseui-text-input-error firebaseui-id-email-error">{emailError}</p>
              </div> : null }

              { step === Steps.LOGIN ? <div className="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label is-upgraded">
                <label className="mdl-textfield__label firebaseui-label" htmlFor="password">Password</label>
                <input autoFocus id="currentPassword" type="password" name="currentPassword" autoComplete="current-password" className="mdl-textfield__input firebaseui-input firebaseui-id-password" />
              </div> : null }

              { step === Steps.REGISTER ? <div className="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label is-upgraded">
                <label className="mdl-textfield__label firebaseui-label" htmlFor="newPassword">Password</label>
                <input autoFocus id="newPassword" type="password" name="newPassword" autoComplete="new-password" className="mdl-textfield__input firebaseui-input firebaseui-id-password" />
              </div> : null }

              { step === Steps.REGISTER ? <div className="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label is-upgraded">
                <label className="mdl-textfield__label firebaseui-label" htmlFor="confirmPassword">Confirm Password</label>
                <input id="confirmPassword" type="password" name="confirmPassword" autoComplete="current-password" className="mdl-textfield__input firebaseui-input firebaseui-id-password" />
              </div> : null }

              { passwordError ? <div className="firebaseui-error-wrapper">
                <p className="firebaseui-error firebaseui-text-input-error firebaseui-id-password-error">{passwordError}</p>
              </div> : null }
            </div> }

          </div>
          { processing ? null : <div className="firebaseui-card-actions">
            <div className="firebaseui-form-actions">
              <button type="button" onClick={this.goToInitialStep} className="firebaseui-id-secondary-link firebaseui-button mdl-button mdl-js-button mdl-button--primary">Cancel</button>
              <button type="submit" className="firebaseui-id-submit firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">{actionButton}</button>
            </div>
          </div> }
        </form>
      </div>
    );
  };

  renderInitialButtons() {
    return (
      <div>
        <ul className="firebaseui-idp-list">
          <li className="firebaseui-list-item">
            <button onClick={this.signInWithGoogle} className="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-google firebaseui-id-idp-button" data-provider-id="google.com">
              <span className="firebaseui-idp-icon-wrapper">
                <img className="firebaseui-idp-icon" alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" />
              </span>
              <span className="firebaseui-idp-text firebaseui-idp-text-long">Sign in with Google</span>
              <span className="firebaseui-idp-text firebaseui-idp-text-short">Google</span>
            </button>
          </li>
          <li className="firebaseui-list-item">
            <button onClick={this.signInWithEmail} className="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-password firebaseui-id-idp-button" data-provider-id="password">
              <span className="firebaseui-idp-icon-wrapper">
                <img className="firebaseui-idp-icon" alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg" />
              </span>
              <span className="firebaseui-idp-text firebaseui-idp-text-long">Sign in with email</span>
              <span className="firebaseui-idp-text firebaseui-idp-text-short">Email</span>
            </button>
          </li>
        </ul>
      </div>
    );
  }

  render() {
    const { step } = this.state;

    return (
      <div lang="en">
        <div className="firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in firebaseui-use-spinner">
          <div className="firebaseui-card-content">
            { step === Steps.INITIAL ? this.renderInitialButtons() : this.renderEmailPasswordForm() }
          </div>
        </div>
      </div>
    );
  }
}

export const Auth = compose(withFirebase, withAuth)(AuthBase);
